import { useContext } from 'react';
import { ResourceContext } from './resourceContext.core';

export function useCurrentResource(): string | null {
  const context = useContext(ResourceContext);
  return context.resource;
}

export function useResolvedResource(explicitResource?: string): string | null {
  const contextResource = useCurrentResource();
  return explicitResource ?? contextResource;
}
